import React, { forwardRef, memo } from 'react'

const GiftIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="34.3"
      height="33.6"
      viewBox="0 0 34.3 33.6"
      fill="none"
      {...props}>
      <g
        stroke="currentColor"
        strokeWidth="2.259"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none">
        <path d="M28.856 10.4997H5.756c-.58 0-1.05.47-1.05 1.05v4.2c0 .58.47 1.05 1.05 1.05h23.1c.58 0 1.05-.47 1.05-1.05v-4.2c0-.58-.47-1.05-1.05-1.05Z" />
        <path d="M27.806 16.7997v9.45c0 .278-.11.545-.307.742-.197.197-.464.308-.743.308H7.856a1.05 1.05 0 0 1-1.05-1.05v-9.45" />
        <path d="M17.306 10.4997v16.8" />
        <path d="M23.7096 4.09616c1.2258 1.22574 1.298 3.28914 0 4.43884C21.4901 10.5 17.306 10.5 17.306 10.5s0-4.184 1.965-6.40384c1.1498-1.29807 3.2132-1.22584 4.4386 0Z" />
        <path d="M10.9023 4.09616c-1.22573 1.22574-1.29796 3.28914 0 4.43884C13.1218 10.5 17.306 10.5 17.306 10.5s0-4.184-1.9641-6.40384c-1.1498-1.29807-3.2132-1.22584-4.4396 0Z" />
      </g>
    </svg>
  )
)

GiftIcon.displayName = 'GiftIcon'

export default memo(GiftIcon)
